function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}
console.log(detectIE());
var v = detectIE();
if(v !== false && v < 12) {
  window.document.getElementById('old-ie').style.display = 'block';
  window.document.getElementById('continue').style.display = 'block';
} else {
  // Not IE
  setCookie('browser_check', 1, 60);
  window.location = portal_url;
}


function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  console.log(name + "=" + (value || "")  + expires + "; path=/");
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
window.continueWithOldBrowser = function () {
  setCookie('browser_check', 1, 60);
  window.location = portal_url;
};



// WEBPACK FOOTER //
// ./resources/assets/js/browser.js